$(document).ready(function() {
 $('.customer-review').slick({
    centerMode: true,
    centerPadding: '30%',
    slidesToScroll: 1,
    slidesToShow: 1,
    dots: true,
    arrows: true,
    swipe: true,
    swipeToSlide: true,
   prevArrow: '<button class="slick-prev slick-arrow custom-slider-btn " aria-label="Previous" type="button"><i class="fa fa-angle-left"></i></button>',
    nextArrow: '<button class="slick-next slick-arrow custom-slider-btn " aria-label="Next" type="button"><i class="fa fa-angle-right"></i></button>',
    responsive: [{ 
        breakpoint: 1200,
        settings: {
            slidesToShow: 1,
            centerPadding: '0%',
            adaptiveHeight: true,
            dots: true
        }
    }]
});

   $('.launch_real_slider').slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    dots: true,
    arrows: false,
    infinite: false
});

  var maxHeight = 0;

$(".launch_bussiness_single_in").each(function(){
   if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
});

$(".launch_bussiness_single_in").height(maxHeight);
  

   $('.launch_bussiness_slider').slick({
    slidesToScroll: 1,
    slidesToShow: 3,
    dots: true,
    arrows: false,
    infinite: false,
     responsive: [{ 
        breakpoint: 1200,
        settings: {
            slidesToShow: 1,
          adaptiveHeight: true
        }
    }]
});
  
$(".launch_store_faq ul li h3").click(function(){
    var get_number = $(this).data("index");
    
    if($(this).parent().hasClass("active_faq")){
     $(this).parent().removeClass("active_faq"); 
    }else{
      $(".launch_store_faq ul li").removeClass("active_faq");
      $(this).parent().addClass("active_faq");
      $('.launch_real_slider').slick('slickGoTo', get_number);
    }
  });

  $(".nav-toggler").click(function(){
    $(this).toggleClass("active");
    $(".launch_mobile_menu").slideToggle();
  });

if($(window).width() < 768)
{
      $('.footer-container-first-column h4').click(function(){
        var isAlreadyOpen = $(this).nextAll('.footer-list').first().is(":visible");
        $('.footer-list').slideUp();
        $('.fa-solid').removeClass('fa-chevron-up').addClass('fa-chevron-down');

        if (!isAlreadyOpen) {
            $(this).nextAll('.footer-list').first().slideDown();
            $(this).find('.fa-solid').removeClass('fa-chevron-down').addClass('fa-chevron-up');
        }
    });
}
});